"use client";

import * as React from "react";

// The web app is light-mode only. These types are kept so consumers that
// referenced the old theme API (e.g. the Toaster) keep compiling.
export type ThemeMode = "light";
export type ResolvedTheme = "light";

interface ThemeContextProps {
  themeMode: ThemeMode;
  resolvedTheme: ResolvedTheme;
}
const ThemeContext = React.createContext<ThemeContextProps | undefined>(
  undefined,
);

export function ThemeProvider({ children }: React.PropsWithChildren) {
  React.useEffect(() => {
    const root = document.documentElement;
    root.classList.remove("dark", "auto");
    root.classList.add("light");
  }, []);

  return (
    <ThemeContext value={{ themeMode: "light", resolvedTheme: "light" }}>
      {children}
    </ThemeContext>
  );
}

export function useTheme() {
  const context = React.use(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
}
